var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSub08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_305_959)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96483 0.686262C6.89074 0.421927 5.76664 0.439204 4.70121 0.73642C3.63576 1.03364 2.66503 1.60074 1.88289 2.38289C1.10074 3.16503 0.533636 4.13576 0.23642 5.20121C-0.0607965 6.26664 -0.078073 7.39074 0.186262 8.46483L10.0011 48.1529L10.0032 48.1614C10.2812 49.2659 10.8477 50.2773 11.6448 51.0911C12.4419 51.905 13.441 52.4921 14.5398 52.793C15.6386 53.0939 16.7976 53.0973 17.8981 52.8033C18.9968 52.5093 19.9978 51.9294 20.7991 51.1224L20.8032 51.1186L27.8527 44.069L43.4803 59.6964C44.3134 60.5296 45.6621 60.5339 46.5004 59.7067L59.3576 47.021C59.7643 46.6199 59.9936 46.0734 59.9957 45.503C59.9974 44.9321 59.7716 44.384 59.3679 43.9803L43.7404 28.3527L50.7964 21.2966L50.8059 21.287C51.615 20.4676 52.1893 19.4459 52.4687 18.3287C52.7477 17.2116 52.7216 16.04 52.3933 14.9363C52.065 13.8326 51.4457 12.8374 50.6014 12.0547C49.7649 11.2799 48.738 10.7414 47.6254 10.4944L7.96483 0.686262Z",
    fill: "url(#paint0_linear_305_959)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_305_959",
    x1: 29.9979,
    y1: 0.5,
    x2: 29.9979,
    y2: 60.3242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F84343"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_305_959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSub08);
export default __webpack_public_path__ + "static/media/sub_08.e2e2e4accf15a1ad865e4ec3fe120805.svg";
export { ForwardRef as ReactComponent };